/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { DashboardPageVistitsChart } from "bd-web-components"
import { dateShortForNewer } from "../../utils/dateFormat"

interface PageVisitsContainerProps {
  visitors: any
}

const PageVisitsContainer: React.FC<PageVisitsContainerProps> = ({ visitors }) => {
  let listLabelsVisitors: any = []
  let listDataOldVisitors: any = []

  const shortedVisitors = dateShortForNewer(visitors)

  if (shortedVisitors) {
    shortedVisitors.forEach((data: any) => {
      listLabelsVisitors.push(`${data.dia.slice(8,10)}/${data.dia.slice(5,7)}`)
      listDataOldVisitors.push(data.visitasTotais);
    });
  }

  const pageVisitsChart = {
    labels: listLabelsVisitors,
    chartData: {
      datasets: [
        {
          label: "Visitas antigas",
          data: listDataOldVisitors,
        },
      ],
    },
  }

  return (
    <DashboardPageVistitsChart
      labels={pageVisitsChart.labels}
      chartData={{
        datasets: [
          {
            label: pageVisitsChart.chartData.datasets[0].label,
            data: pageVisitsChart.chartData.datasets[0].data
          },
        ],
      }}
    />
  )
}

export default PageVisitsContainer
